import RouteView from "@/layouts/RouteView.vue";
export default {
  path: "/my",
  name: "my",
  redirect: "/my/My",
  component: RouteView,
  meta: {
    title: "个人资料",
    icon: "user-o",
    showNavBar: true,
  },
  children: [
    {
      path: "/my/My",
      name: "My",
      component: () =>
        import(/* webpackChunkName: "order" */ "@/views/my/My.vue"),
      meta: {
        title: "个人资料",
        showNavBar: true,
      },
    },
    {
      path: "/my/SecurityCenter",
      name: "SecurityCenter",
      component: () =>
        import(/* webpackChunkName: "order" */ "@/views/my/SecurityCenter.vue"),
      meta: {
        title: "安全中心",
        showNavBar: false,
      },
    },
    {
      path: "/my/config",
      name: "config",
      component: () =>
        import(/* webpackChunkName: "order" */ "@/views/my/Config.vue"),
      meta: {
        title: "系统维护",
        showNavBar: false,
      },
    },
    {
      path: "/my/message",
      name: "messageRemind",
      component: () =>
        import(/* webpackChunkName: "order" */ "@/views/my/Message.vue"),
      meta: {
        title: "消息提醒",
        showNavBar: false,
      },
    },
    {
      path: "/my/Feedback",
      name: "Feedback",
      component: () =>
        import(/* webpackChunkName: "order" */ "@/views/my/Feedback.vue"),
      meta: {
        title: "意见反馈",
        showNavBar: false,
      },
    },
    {
      path: "/my/aboutus",
      name: "aboutus",
      component: () =>
        import(/* webpackChunkName: "order" */ "@/views/my/AboutUs.vue"),
      meta: {
        title: "关于我们",
        showNavBar: false,
      },
    },
    {
      path: "/my/WechatSetting",
      name: "wechatSetting",
      component: () =>
        import(/* webpackChunkName: "order" */ "@/views/my/WechatSetting.vue"),
      meta: {
        title: "微信消息设置",
        showNavBar: false,
      },
    },
  ],
};
